// Etichette leggibili per il tipo di risorsa (campo stringa libero lato backend)

export const TIPO_RISORSA_LABELS: Record<string, string> = {
  contanti: 'Contanti',
  conto_corrente: 'Conto Corrente',
  carta: 'Carta',
  altro: 'Altro',
};

export const formatTipoRisorsa = (tipo?: string): string => {
  if (!tipo) return '';
  return TIPO_RISORSA_LABELS[tipo] || tipo.charAt(0).toUpperCase() + tipo.slice(1).replace(/_/g, ' ');
};
